import React, { useState, useEffect } from 'react';
import CustomLineChart from './CustomLineChart';
import * as Constants from '../../../requests/URLConstants';
import DashboardTable from '../DashboardTable';
import callPostApi from 'requests/PostRequests';
import { ContentSwitcher, Switch } from 'carbon-components-react';
import * as DashboardConstants from '.././DashboardConstants';

const DetailedUtilizationReport = (props) => {
    // const [vmList, setVmList] = useState([]);
    // const [selectedResources, setSelectedResources] = useState([]);
    const [botUtilizationLoading, setBotUtilizationLoading] = useState(false);
    const [botUtilizationTableData, setBotUtilizationTableData] = useState([]);
    const [botUtilizationTableHeader, setBotUtilizationTableHeader] = useState([]);
    const [botUtilizationGraphData, setBotUtilizationGraphData] = useState([])
    const [selectedUtilizationType, setSelectedUtilizationType] = useState('averageUtilization');
    const [selectedDays, setSelectedDays] = useState([]);
    const [selectedSeconds, setSelectedSeconds] = useState();
    const [selectedVMTableView, setSelectedVMTableView] = useState('hrView');
    const dateRangeForUtilization = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00",
    "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00",
    "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "00:00"];
    const days = [{label:'Mon',id: 1}, {label:'Tue',id: 2}, {label:'Wed',id: 3},
    {label:'Thu',id: 4}, {label:'Fri',id: 5}, {label:'Sat',id: 6}, {label:'Sun',id: 7}];

    useEffect(() => {
        if(selectedUtilizationType === 'peakUtilization') {
            if(selectedVMTableView === 'hrView') {
                getHourlyPeakBotUtilizationData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedDays);
            } else if(selectedVMTableView === 'dateView') {
                getDateWisePeakBotUtilizationData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedDays);
            } else {
                getDayWisePeakBotUtilizationData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedDays);
            }
        } else {
            if(selectedVMTableView === 'hrView') {
                getHourlyAverageBotUtilizationData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedDays);
            } else if(selectedVMTableView === 'dateView') {
                getDateWiseAverageBotUtilizationData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedDays);
            } else {
                getDayWiseAverageBotUtilizationData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace, selectedDays);
            }
        }
    }, [selectedVMTableView, selectedUtilizationType, selectedDays.length, selectedSeconds, props.preferencesChanged]);

    // useEffect(() => {
    //     getResourceList(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    // }, [props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace]);

    // const getResourceList = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
    //     if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
    //         let bodyJSON = {};
    //         bodyJSON = props.getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
    //         callPostApi(Constants.GETRESOURCELISTFORUITILIZATION, {
    //             'Content-Type': 'application/json'
    //         }, bodyJSON)
    //         .then(resp => {
    //             setVmList(resp);
    //         }).catch((error) => {
    //         });
    //     }
    // }
    const prepareHourlyBotUtilizationData = (response) => {
        // let vmList = [];
        let graphObj, tableObj;
        let graphData = [];
        let tableData = [];
        let hourlyBotUtilizationtableHeader = [
            {
                key: 'timeIntervals',
                header: DashboardConstants.TimeIntervals
            }
        ];
        if(response.length) {
            let maxGraphResources = response.slice(0, 15);
            for(let j = 0; j < dateRangeForUtilization.length; j++) {
                if(dateRangeForUtilization[j] && dateRangeForUtilization[j+1]) {
                    tableObj = {
                        id: (j+1).toString(),
                        timeIntervals: dateRangeForUtilization[j] + "-" + dateRangeForUtilization[j+1]
                    };
                    for(let i = 0; i < response.length; i++) {
                        // used tostring to display 0 because dashboardTable display "-" in place of numeric 0
                        tableObj[response[i].key] = response[i].ts[j] ? ((response[i].ts[j]).toFixed(2))+"%": (response[i].ts[j] || 0).toString()+"%";
                    }
                    tableData.push(tableObj);
                }
            }
            for(let i = 0; i < maxGraphResources.length; i++) {
                for(let j = 0; j < dateRangeForUtilization.length-1; j++) {
                    graphObj = {
                        group: response[i].key,
                        date: dateRangeForUtilization[j],
                        value: response[i].ts[j]
                    }
                    graphData.push(graphObj);
                }
                hourlyBotUtilizationtableHeader.push({key: response[i].key, header: response[i].key})
            }
            // for(let i = 0; i < response.length; i++) {
            //     vmList.push(response[i].key);
            // }
            // let uniqueVMs = [...new Set(vmList)];
            setBotUtilizationTableHeader(hourlyBotUtilizationtableHeader);
            // setSelectedResources(uniqueVMs);
        }
        return {tableData, graphData}
    };

    const getHourlyAverageBotUtilizationData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, selectedDays) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotUtilizationLoading(true);
            let formattedData = [];
            let bodyJSON = {};
            bodyJSON = props.getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            // bodyJSON.resourcelist = selectedResources;
            bodyJSON.excludedays = selectedDays;
            bodyJSON.excludesecs = selectedSeconds;
            callPostApi(Constants.GETHOURLYAVGBOTUTILIZATION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareHourlyBotUtilizationData(resp);
                setBotUtilizationGraphData(formattedData.graphData);
                setBotUtilizationTableData(formattedData.tableData);
                setBotUtilizationLoading(false);
            }).catch((error) => {
                setBotUtilizationLoading(false);
            });
        }
    };

    const getHourlyPeakBotUtilizationData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, selectedDays) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotUtilizationLoading(true);
            let formattedData = [];
            let bodyJSON = props.getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            // bodyJSON.resourcelist = selectedResources;
            bodyJSON.excludedays = selectedDays;
            bodyJSON.excludesecs = selectedSeconds;
            callPostApi(Constants.GETHOURLYPEAKBOTUTILIZATION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareHourlyBotUtilizationData(resp, selectedUtilizationType);
                setBotUtilizationGraphData(formattedData.graphData);
                setBotUtilizationTableData(formattedData.tableData);
                setBotUtilizationLoading(false);
            }).catch((error) => {
                setBotUtilizationLoading(false);
            });
        }
    };

    const prepareDateWiseBotUtilizationData = (response) => {
        let tableObj = {};
        let tableData = [];
        // let vmList = [];
        let util = 0;
        if(response.length) {
            let tableHeader = [
                {
                    key: 'timeIntervals',
                    header: DashboardConstants.TimeIntervals
                }
            ];
            for(let i = 0; i < response.length; i++) {
                // vmList.push(response[i].key);
                tableHeader.push({key: response[i].key, header: response[i].key });
                for(let j = 0; j < response[i].ts.length; j++) {
                    tableObj = {};
                    util = response[i].ts[j].avgUtil || response[i].ts[j].maxUtil;
                    if(i === 0) {
                        tableObj['id'] = response[i].ts[j].date;
                        tableObj['timeIntervals'] = response[i].ts[j].date;
                        tableObj[response[i].key] = util ? util.toFixed(2)+"%" : (util || 0).toString()+"%";
                        tableData.push(tableObj);
                    } else {
                        for (let k = 0; k < tableData.length; k++) {
                            if(tableData[k].timeIntervals === response[i].ts[j].date) {
                                tableData[k][response[i].key] =  util ? util.toFixed(2)+"%" : (util || 0).toString()+"%";
                            }
                        }
                    }
                }
            }
            // let uniqueVMs = [...new Set(vmList)];
            // setSelectedResources(uniqueVMs);
            setBotUtilizationTableHeader(tableHeader);
        }
        return tableData
    };

    const getDateWiseAverageBotUtilizationData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, selectedDays) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotUtilizationLoading(true);
            setBotUtilizationTableData([]);
            let formattedData = [];
            let bodyJSON = {};
            bodyJSON = props.getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            // bodyJSON.resourcelist = selectedResources;
            bodyJSON.excludedays = selectedDays;
            bodyJSON.excludesecs = selectedSeconds;
            callPostApi(Constants.GETDATEWISEAVGBOTUTILIZATION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareDateWiseBotUtilizationData(resp);
                setBotUtilizationTableData(formattedData);
                setBotUtilizationLoading(false);
            }).catch((error) => {
                setBotUtilizationLoading(false);
            });
        }
    };

    const getDateWisePeakBotUtilizationData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, selectedDays) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotUtilizationLoading(true);
            setBotUtilizationTableData([]);
            let formattedData = [];
            let bodyJSON = {};
            bodyJSON = props.getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            // bodyJSON.resourcelist = selectedResources;
            bodyJSON.excludedays = selectedDays;
            bodyJSON.excludesecs = selectedSeconds;
            callPostApi(Constants.GETDATEWISEPEAKBOTUTILIZATION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareDateWiseBotUtilizationData(resp);
                setBotUtilizationTableData(formattedData);
                setBotUtilizationLoading(false);
            }).catch((error) => {
                setBotUtilizationLoading(false);
            });
        }
    };

    const convertIdToDay = (id) => {
        let day = days.find(day => day.id === id);
        return day.label;
    };

    const prepareDayWiseBotUtilizationData = (response) => {
        let tableObj = {};
        let tableData = [];
        let graphObj = {};
        let graphData = [];
        // let vmList = [];
        let util = 0;
        if(response.length) {
            let tableHeader = [
                {
                    key: 'timeIntervals',
                    header: DashboardConstants.TimeIntervals
                }
            ];
            let maxGraphResources = response.slice(0, 15);
            for(let i = 0; i < response.length; i++) {
                // vmList.push(response[i].key);
                tableHeader.push({key: response[i].key, header: response[i].key });
                for(let j = 0; j < response[i].ts.length; j++) {
                    tableObj = {};
                    util = response[i].ts[j].avgUtil || response[i].ts[j].maxUtil;
                    if(i === 0) {
                        tableObj['id'] = response[i].ts[j].date;
                        tableObj['timeIntervals'] = convertIdToDay(response[i].ts[j].date);
                        tableObj[response[i].key] = util ? util.toFixed(2)+"%" : (util || 0).toString()+"%";
                        tableData.push(tableObj);
                    } else {
                        for (let k = 0; k < tableData.length; k++) {
                            if(tableData[k].timeIntervals === convertIdToDay(response[i].ts[j].date)) {
                                tableData[k][response[i].key] =  util ? util.toFixed(2)+"%" : (util || 0).toString()+"%";
                            }
                        }
                    }
                }
            }
            for(let i = 0; i < maxGraphResources.length; i++) {
                for(let j = 0; j < response[i].ts.length; j++) {
                    util = response[i].ts[j].avgUtil || response[i].ts[j].maxUtil;
                    graphObj = {
                        group: response[i].key,
                        date: convertIdToDay(response[i].ts[j].date),
                        value: util ? util : 0
                    }
                    graphData.push(graphObj);
                }
            }
            // let uniqueVMs = [...new Set(vmList)];
            // setSelectedResources(uniqueVMs);
            setBotUtilizationTableHeader(tableHeader);
        }
        return {tableData, graphData}
    };

    const getDayWiseAverageBotUtilizationData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, selectedDays) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotUtilizationLoading(true);
            setBotUtilizationTableData([]);
            let formattedData = [];
            let bodyJSON = {};
            bodyJSON = props.getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            // bodyJSON.resourcelist = selectedResources;
            bodyJSON.excludedays = selectedDays;
            bodyJSON.excludesecs = selectedSeconds;
            callPostApi(Constants.GETDAYWISEAVGBOTUTILIZATION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareDayWiseBotUtilizationData(resp);
                setBotUtilizationTableData(formattedData.tableData);
                setBotUtilizationGraphData(formattedData.graphData);
                setBotUtilizationLoading(false);
            }).catch((error) => {
                setBotUtilizationLoading(false);
            });
        }
    };

    const getDayWisePeakBotUtilizationData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace, selectedDays) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotUtilizationLoading(true);
            setBotUtilizationTableData([]);
            let formattedData = [];
            let bodyJSON = {};
            bodyJSON = props.getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            // bodyJSON.resourcelist = selectedResources;
            bodyJSON.excludedays = selectedDays;
            bodyJSON.excludesecs = selectedSeconds;
            callPostApi(Constants.GETDAYWISEPEAKBOTUTILIZATION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareDayWiseBotUtilizationData(resp);
                setBotUtilizationTableData(formattedData.tableData);
                setBotUtilizationGraphData(formattedData.graphData);
                setBotUtilizationLoading(false);
            }).catch((error) => {
                setBotUtilizationLoading(false);
            });
        }
    };

    const toggleUtilization = (utilizationType) => {
        setSelectedUtilizationType(utilizationType);
    };

    // const filterUtilizationByResources = (e) => {
    //     setSelectedResources(e.selectedItems);
    // };

    const filterUtilizationByDays = (e) => {
        let idList = e.selectedItems.map(function (obj) {
            return obj.id;
        });
        setSelectedDays(idList);
    };

    const filterUtilizationByTime = (e) => {
        setSelectedSeconds(e.imaginaryTarget.value);
    };

    const switchView = (e) => {
        setSelectedVMTableView(e.name);
    };

    return (
        <>
            <section>
                <CustomLineChart lineGraphData={botUtilizationGraphData}
                    loading={botUtilizationLoading}
                    title={selectedUtilizationType === 'averageUtilization' ? DashboardConstants.AverageUtilization : DashboardConstants.PeakUtilization}
                    graphTitle={DashboardConstants.Utilization}
                    graphXAxisTitle = {DashboardConstants.Hours}
                    isPercentage={true}
                    clientName={DashboardConstants.Kantar}
                    toggleUtilization={toggleUtilization}
                    filterUtilizationByDays={filterUtilizationByDays}
                    filterUtilizationByTime={filterUtilizationByTime}
                    selectedUtilizationType={selectedUtilizationType}
                    selectedVMTableView={selectedVMTableView}
                    days={days}
                    downloadableData={botUtilizationTableData}
                    downloadableHeader={botUtilizationTableHeader}
                />
            </section>
            <section className="border-bottom vm-table">
                <div className="content-switcher">
                    {selectedUtilizationType === 'averageUtilization' ?
                        <ContentSwitcher selectedIndex={0} onChange={switchView}>
                            <Switch name={'hrView'} text={DashboardConstants.HourView} />
                            <Switch name={'dayView'} text={DashboardConstants.DayView} />
                            <Switch name={'dateView'} text={DashboardConstants.DateView} />
                        </ContentSwitcher>
                    :
                        <ContentSwitcher selectedIndex={0} onChange={switchView}>
                            <Switch name={'hrView'} text={DashboardConstants.HourView} />
                            <Switch name={'dayView'} text={DashboardConstants.DayView} />
                        </ContentSwitcher>
                    }
                </div>
                <div className="bold-border-table">
                    <DashboardTable loading={botUtilizationLoading} rows={botUtilizationTableData} headers={botUtilizationTableHeader}
                    showPagination={true} isSortable={true} />
                </div>
            </section>
        </>
    );
};

export default DetailedUtilizationReport;
